/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const formatBytes = (bytes: number, decimals?: number, spaceBetweenUnit?: boolean): string => {
  const k = 1024,
    dm = decimals || 2,
    sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / k ** i).toFixed(dm))}${spaceBetweenUnit ? ' ' : ''}${sizes[i]}`;
};
